module.exports = __webpack_public_path__ + "9494c8584e0dd8a30ff22a259b79ceb2.MP3";